import type { CSSProperties } from 'react';
import type { LayerRect } from './types';

/** Fractional rect (+ rotation/opacity) → absolute CSS. Shared by the editor
 *  preview handles and the Remotion <LayerOverlay> so preview == export. */
export function layerRectToStyle(
  { rect, rotation, opacity }: { rect: LayerRect; rotation: number; opacity: number },
): CSSProperties {
  return {
    position: 'absolute',
    left: `${rect.x * 100}%`,
    top: `${rect.y * 100}%`,
    width: `${rect.w * 100}%`,
    height: `${rect.h * 100}%`,
    transform: `rotate(${rotation}deg)`,
    transformOrigin: 'center center',
    opacity,
    objectFit: 'contain',
    // Tailwind preflight applies `img, video { max-width: 100% }`, which caps
    // the media at the composition width (its containing block is the
    // <AbsoluteFill>) and silently stops a resize from growing any further.
    // The Remotion bundle loads no stylesheet, so without this the export
    // would render larger than the preview.
    maxWidth: 'none',
    maxHeight: 'none',
  };
}
